export default __webpack_public_path__ + "static/media/wallet_connect.dfa25e47.svg";